import { quoteMap } from "./quoteAction";

const initialState = {
  isLoading: false,
  ContactList: {},
  refreshContactList: true,
  searchBy: "",
  countries: [],
  searchText: "",
  pageNameList: [],
  skip: 0,
  limit: 50,
  selectedContact: {},
  audioType: "all",
  leadType: "all",
  callOutcomeFilter: "all",
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case quoteMap.GET_ALL_QUOTE_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case quoteMap.GET_ALL_QUOTE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        ContactList: action.payload,
        refreshContactList: false,
      };
    }
    case quoteMap.GET_ALL_QUOTE_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshContactList: false,
      };
    }

    case quoteMap.SEARCH_TEXT_CHANGE: {
      return {
        ...state,
        searchText: action.payload,
        refreshContactList: true,
      };
    }
    case quoteMap.SET_QUOTE_BATCH_NUMBER: {
      return {
        ...state,
        skip: action.payload,
        refreshContactList: true,
      };
    }
    case quoteMap.SET_LIMIT: {
      return {
        ...state,
        limit: action.payload,
        skip: 0,
        refreshContactList: true,
      };
    }
    case quoteMap.GET_QUOTE_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case quoteMap.GET_QUOTE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        ContactList: action.payload,
        refreshContactList: false,
      };
    }
    case quoteMap.GET_QUOTE_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshContactList: false,
      };
    }
    case quoteMap.GET_QUOTE_PAGE_NAME_LIST_SUCCESS: {
      return {
        ...state,
        pageNameList: action.payload,
      };
    }
    case quoteMap.SET_AUDIO_TYPE: {
      return {
        ...state,
        audioType: action.payload,
        refreshContactList: true,
      };
    }
    case quoteMap.SET_LEAD_TYPE: {
      return {
        ...state,
        leadType: action.payload,
        skip: 0,
        refreshContactList: true,
      };
    }
    case quoteMap.SET_CALL_OUTCOME_FILTER: {
      return {
        ...state,
        callOutcomeFilter: action.payload,
        skip: 0,
        refreshContactList: true,
      };
    }
    case quoteMap.UPDATE_LEAD_TYPE_IN_LIST: {
      const { id, leadType } = action.payload;
      if (!state.ContactList || !Array.isArray(state.ContactList.records)) {
        return state;
      }
      return {
        ...state,
        ContactList: {
          ...state.ContactList,
          records: state.ContactList.records.map((record) =>
            record._id === id ? { ...record, leadType } : record,
          ),
        },
      };
    }
    default:
      return { ...state };
  }
};
